var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 362.256,
    height: 180.699,
    viewBox: "0 0 362.256 180.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_95941",
    x: 184.162,
    y: 0,
    width: 178.094,
    height: 180.698,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.031
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_95951",
    x: 0,
    y: 0,
    width: 178.094,
    height: 180.699,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.031
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_5985",
    x: 105.325,
    y: 0.07,
    width: 151.202,
    height: 154.855,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.031
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_135347",
    "data-name": "Group 135347",
    transform: "translate(-455.751 -367.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132577",
    "data-name": "Group 132577",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 688.694, 379.894)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.97, -0.26, 0.26, 0.97, -228.11, 48.7)",
    filter: "url(#Path_95941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95941-2",
    "data-name": "Path 95941",
    d: "M8.007.053,107.3,0a7.931,7.931,0,0,1,7.944,7.93l-.055,103a7.951,7.951,0,0,1-7.953,7.938l-99.289.053A7.931,7.931,0,0,1,0,110.995l.055-103A7.951,7.951,0,0,1,8.007.053Z",
    transform: "matrix(0.97, 0.26, -0.26, 0.97, 232.94, 12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_132242",
    "data-name": "Group 132242",
    transform: "translate(7.469 7.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128707",
    "data-name": "Group 128707",
    transform: "translate(69.892 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95942",
    "data-name": "Path 95942",
    d: "M5.3.01,24.381,0a5.287,5.287,0,0,1,5.3,5.286l0,3.063a5.3,5.3,0,0,1-5.3,5.292L5.3,13.651A5.287,5.287,0,0,1,0,8.365L0,5.3A5.3,5.3,0,0,1,5.3.01Z",
    transform: "translate(0 0)",
    fill: "#f1f4fb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_95943",
    "data-name": "Path 95943",
    d: "M2.652.029,57.094,0a2.644,2.644,0,0,1,2.648,2.643l0,2.9A2.65,2.65,0,0,1,57.09,8.185L2.648,8.213A2.644,2.644,0,0,1,0,5.57l0-2.9A2.65,2.65,0,0,1,2.652.029Z",
    transform: "translate(0 2.748)",
    fill: "#f1f4fb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_95944",
    "data-name": "Path 95944",
    d: "M5.307.047,93.886,0a5.287,5.287,0,0,1,5.3,5.286l0,9.3a5.3,5.3,0,0,1-5.3,5.292L5.3,19.924A5.287,5.287,0,0,1,0,14.638l0-9.3A5.3,5.3,0,0,1,5.307.047Z",
    transform: "translate(7.421 91.203)",
    fill: "#f1f4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95945",
    "data-name": "Path 95945",
    d: "M2.652.015,30.543,0a2.644,2.644,0,0,1,2.648,2.643l0,2.9a2.65,2.65,0,0,1-2.651,2.646L2.648,8.2A2.644,2.644,0,0,1,0,5.556l0-2.9A2.65,2.65,0,0,1,2.652.015Z",
    transform: "translate(7.459 29.267)",
    fill: "#f1f4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95946",
    "data-name": "Path 95946",
    d: "M2.652.015,30.543,0a2.644,2.644,0,0,1,2.648,2.643l0,2.9a2.65,2.65,0,0,1-2.651,2.646L2.648,8.2A2.644,2.644,0,0,1,0,5.556l0-2.9A2.65,2.65,0,0,1,2.652.015Z",
    transform: "translate(7.445 56.55)",
    fill: "#f1f4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95947",
    "data-name": "Path 95947",
    d: "M2.653.015,31.324,0a2.644,2.644,0,0,1,2.648,2.643l0,4.454a2.65,2.65,0,0,1-2.651,2.646L2.648,9.759A2.644,2.644,0,0,1,0,7.116L0,2.661A2.65,2.65,0,0,1,2.653.015Z",
    transform: "translate(7.437 69.8)",
    fill: "#f1f4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95948",
    "data-name": "Path 95948",
    d: "M2.652.022,43.818,0a2.644,2.644,0,0,1,2.648,2.643l0,2.9a2.65,2.65,0,0,1-2.651,2.646L2.648,8.206A2.644,2.644,0,0,1,0,5.563l0-2.9A2.65,2.65,0,0,1,2.652.022Z",
    transform: "translate(7.453 40.563)",
    fill: "#f1f4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95949",
    "data-name": "Path 95949",
    d: "M2.652.018,36.009,0a2.644,2.644,0,0,1,2.648,2.643l0,2.9A2.65,2.65,0,0,1,36,8.185L2.648,8.2A2.644,2.644,0,0,1,0,5.559l0-2.9A2.65,2.65,0,0,1,2.652.018Z",
    transform: "translate(69.146 40.534)",
    fill: "#f1f4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95950",
    "data-name": "Path 95950",
    d: "M2.652.011,23.514,0a2.644,2.644,0,0,1,2.648,2.643l0,2.9A2.65,2.65,0,0,1,23.51,8.185L2.648,8.2A2.644,2.644,0,0,1,0,5.552l0-2.9A2.65,2.65,0,0,1,2.652.011Z",
    transform: "translate(81.647 29.232)",
    fill: "#f1f4fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_132575",
    "data-name": "Group 132575",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 473.751, 409.721)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.97, 0.26, -0.26, 0.97, -6.56, -45.06)",
    filter: "url(#Path_95951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95951-2",
    "data-name": "Path 95951",
    d: "M7.944,0l99.289.053a7.951,7.951,0,0,1,7.953,7.938l.055,103a7.931,7.931,0,0,1-7.944,7.93l-99.289-.053a7.951,7.951,0,0,1-7.953-7.938L0,7.93A7.931,7.931,0,0,1,7.944,0Z",
    transform: "matrix(0.97, -0.26, 0.26, 0.97, 18, 41.83)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_132242-2",
    "data-name": "Group 132242",
    transform: "translate(7.422 7.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128707-2",
    "data-name": "Group 128707",
    transform: "translate(69.892 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95952",
    "data-name": "Path 95952",
    d: "M5.3,0,24.373.01a5.3,5.3,0,0,1,5.3,5.292l0,3.063a5.287,5.287,0,0,1-5.3,5.286L5.3,13.641A5.3,5.3,0,0,1,0,8.349L0,5.286A5.287,5.287,0,0,1,5.3,0Z",
    transform: "translate(0 0)",
    fill: "#f0f4fb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_95953",
    "data-name": "Path 95953",
    d: "M2.648,0,57.09.029A2.65,2.65,0,0,1,59.74,2.675l0,2.9a2.644,2.644,0,0,1-2.648,2.643L2.652,8.185A2.65,2.65,0,0,1,0,5.539l0-2.9A2.644,2.644,0,0,1,2.648,0Z",
    transform: "translate(0 2.69)",
    fill: "#f0f4fb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_95954",
    "data-name": "Path 95954",
    d: "M5.3,0,93.875.047a5.3,5.3,0,0,1,5.3,5.292l0,9.3a5.287,5.287,0,0,1-5.3,5.286L5.307,19.877A5.3,5.3,0,0,1,0,14.585l0-9.3A5.287,5.287,0,0,1,5.3,0Z",
    transform: "translate(7.466 91.203)",
    fill: "#f0f4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95955",
    "data-name": "Path 95955",
    d: "M2.648,0l27.89.015a2.65,2.65,0,0,1,2.651,2.646l0,2.9A2.644,2.644,0,0,1,30.543,8.2L2.652,8.185A2.65,2.65,0,0,1,0,5.539l0-2.9A2.644,2.644,0,0,1,2.648,0Z",
    transform: "translate(7.431 29.232)",
    fill: "#f0f4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95956",
    "data-name": "Path 95956",
    d: "M2.648,0l27.89.015a2.65,2.65,0,0,1,2.651,2.646l0,2.9A2.644,2.644,0,0,1,30.543,8.2L2.652,8.185A2.65,2.65,0,0,1,0,5.539l0-2.9A2.644,2.644,0,0,1,2.648,0Z",
    transform: "translate(7.446 56.514)",
    fill: "#f0f4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95957",
    "data-name": "Path 95957",
    d: "M2.648,0,31.319.015A2.65,2.65,0,0,1,33.97,2.661l0,4.454a2.644,2.644,0,0,1-2.648,2.643L2.653,9.744A2.65,2.65,0,0,1,0,7.1L0,2.643A2.644,2.644,0,0,1,2.648,0Z",
    transform: "translate(7.453 69.765)",
    fill: "#f0f4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95958",
    "data-name": "Path 95958",
    d: "M2.648,0,43.814.022a2.65,2.65,0,0,1,2.651,2.646l0,2.9a2.644,2.644,0,0,1-2.648,2.643L2.652,8.185A2.65,2.65,0,0,1,0,5.539l0-2.9A2.644,2.644,0,0,1,2.648,0Z",
    transform: "translate(7.437 40.534)",
    fill: "#f0f4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95959",
    "data-name": "Path 95959",
    d: "M2.648,0,36,.018a2.65,2.65,0,0,1,2.651,2.646l0,2.9A2.644,2.644,0,0,1,36.009,8.2L2.652,8.185A2.65,2.65,0,0,1,0,5.539l0-2.9A2.644,2.644,0,0,1,2.648,0Z",
    transform: "translate(69.13 40.567)",
    fill: "#f0f4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95960",
    "data-name": "Path 95960",
    d: "M2.648,0,23.51.011a2.65,2.65,0,0,1,2.651,2.646l0,2.9A2.644,2.644,0,0,1,23.514,8.2L2.652,8.185A2.65,2.65,0,0,1,0,5.539l0-2.9A2.644,2.644,0,0,1,2.648,0Z",
    transform: "translate(81.619 29.271)",
    fill: "#f0f4fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_132576",
    "data-name": "Group 132576",
    transform: "translate(579.077 379.964)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -123.33, -12.07)",
    filter: "url(#Rectangle_5985)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5985-2",
    "data-name": "Rectangle 5985",
    width: 115.202,
    height: 118.855,
    rx: 12,
    transform: "translate(123.33 12.07)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_132242-3",
    "data-name": "Group 132242",
    transform: "translate(7.42 7.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128707-3",
    "data-name": "Group 128707",
    transform: "translate(69.902 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 29.679,
    height: 13.639,
    rx: 6.82,
    fill: "#f0f4fb"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7206",
    "data-name": "Rectangle 7206",
    width: 59.749,
    height: 8.183,
    rx: 4,
    transform: "translate(0 2.728)",
    fill: "#f0f4fb"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19-2",
    "data-name": "Rectangle 19",
    width: 99.191,
    height: 19.874,
    rx: 8,
    transform: "translate(7.42 91.187)",
    fill: "#f0f4fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7207",
    "data-name": "Rectangle 7207",
    width: 33.194,
    height: 8.183,
    rx: 4,
    transform: "translate(7.42 29.227)",
    fill: "#f0f4fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7211",
    "data-name": "Rectangle 7211",
    width: 33.194,
    height: 8.183,
    rx: 4,
    transform: "translate(7.42 56.505)",
    fill: "#f0f4fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7212",
    "data-name": "Rectangle 7212",
    width: 33.975,
    height: 9.742,
    rx: 4,
    transform: "translate(7.42 69.754)",
    fill: "#f0f4fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7208",
    "data-name": "Rectangle 7208",
    width: 46.471,
    height: 8.183,
    rx: 4,
    transform: "translate(7.42 40.528)",
    fill: "#f0f4fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7209",
    "data-name": "Rectangle 7209",
    width: 38.661,
    height: 8.183,
    rx: 4,
    transform: "translate(69.121 40.528)",
    fill: "#f0f4fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7210",
    "data-name": "Rectangle 7210",
    width: 26.165,
    height: 8.183,
    rx: 4,
    transform: "translate(81.618 29.227)",
    fill: "#f0f4fb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.742595f205c8f975b0be73468b8eaaa0.svg";
export { ForwardRef as ReactComponent };